import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { withRouter } from 'react-router-dom';
import InvestorInvestmentDetailSC from './investor-investment-detail.styled';
import InfoBanner from '../../../components/info-banner';
import ContentWrap from '../../../components/content-wrap';
import { ROUTE_INVESTMENTS } from '../../../constants';
import InvestorInvestmentDetailBanner from '../../../components/investor-investment-detail-banner';
import InvestorInvestmentDetailContent from '../../../components/investor-investment-detail-content';

const _InvestorInvestmentDetail = ({
  match,
  history: { push },
  history,
  getInvestorInvestmentDetail,
  investmentDetail,
  dashboardData,
}) => {
  const fetch = useCallback(() => {
    if (match.params.id) {
      const onBadId = () => {
        push(ROUTE_INVESTMENTS);
      };
      getInvestorInvestmentDetail({
        id: match.params.id,
        offerId: match.params.offerId,
        onBadId,
      });
    }
  }, [getInvestorInvestmentDetail, match.params.id, push, match.params.offerId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <InvestorInvestmentDetailSC>
      <InfoBanner>
        <InvestorInvestmentDetailBanner
          investmentDetail={investmentDetail}
          dashboardData={dashboardData}
          onSuccess={fetch}
        />
      </InfoBanner>
      <ContentWrap>
        <InvestorInvestmentDetailContent
          investmentDetail={investmentDetail}
          dashboardData={dashboardData}
        />
      </ContentWrap>
    </InvestorInvestmentDetailSC>
  );
};

const mapStateToProps = (state) => {
  return {
    investmentDetail: state.investment_detail,
    dashboardData: state.dashboard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getInvestorInvestmentDetail: ActionCreators.getInvestorInvestmentDetail,
    },
    dispatch
  );
};

const InvestorInvestmentDetail = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_InvestorInvestmentDetail)
);

export default InvestorInvestmentDetail;
